export default __webpack_public_path__ + "media/WixMadeforDisplay_W_Bd.a701b2c3.woff";